import { Container, Modal } from "react-bootstrap";
import PrimaryButton, {
  SecondaryButton,
} from "../../../util/Btns/PrimaryButton";

import Close from "../../../Assets/close.svg";
import styles from "./DeleteBuildModal.module.scss";
import { useDeleteBuild } from "../../../hooks/DevAppHooks";

const DeleteBuildModal = ({ showDeleteBuild, setShowDeleteBuild, build }) => {
  const handleClose = () => setShowDeleteBuild(false);
  const { mutate } = useDeleteBuild(build.id);
  const handleSubmit = () => {
    mutate();
  };

  return (
    <>
      <Container>
        <Modal
          show={showDeleteBuild}
          onHide={handleClose}
          centered
          contentClassName={styles.content}
          dialogClassName={styles.dialog}
        >
          <Modal.Header className={styles.header}>
            <Modal.Title>
              <div style={{ padding: "0.25em" }}>
                <span
                  style={{ fontFamily: "JioType-Medium", fontSize: "medium" }}
                >
                  Delete Build
                </span>
              </div>
            </Modal.Title>

            <img
              onClick={() => setShowDeleteBuild(false)}
              style={{ marginTop: "15px" }}
              src={Close}
              height="14"
              width="14"
              alt="cross"
              className="cursor-pointer"
            />
          </Modal.Header>

          <Modal.Body>
            <div className={styles.body}>
              <h4>Are you sure you want to delete this build?</h4>
              <div className={styles.buttonContainer}>
                <SecondaryButton onClick={() => setShowDeleteBuild(false)}>
                  No
                </SecondaryButton>
                <PrimaryButton
                  onClick={() => {
                    handleSubmit();
                    setShowDeleteBuild(false);
                  }}
                >
                  Yes
                </PrimaryButton>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default DeleteBuildModal;
